package co.maytes.standupbot.dashboard.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.dom.A

private const val EXTERNAL_REL = "noopener noreferrer"
private const val EXTERNAL_TARGET = "_blank"

@Composable
fun LinkButton(
    label: String,
    href: String,
    variant: ButtonVariant = ButtonVariant.Secondary,
    size: ButtonSize = ButtonSize.Md,
    modifier: Modifier = Modifier,
    external: Boolean = false,
    enabled: Boolean = true,
    leadingIcon: (@Composable () -> Unit)? = null,
    trailingIcon: (@Composable () -> Unit)? = null,
    fullWidth: Boolean = false,
) {
    A(
        href = if (enabled) href else null,
        attrs = buttonLook(variant, size, fullWidth, interactive = enabled)
            .onClick { event -> if (!enabled) event.preventDefault() }
            .then(modifier)
            .toAttrs {
                if (external && enabled) {
                    attr("target", EXTERNAL_TARGET)
                    attr("rel", EXTERNAL_REL)
                }
                if (!enabled) {
                    attr("aria-disabled", "true")
                    attr("role", "link")
                }
            },
    ) {
        if (leadingIcon != null) IconSlot(leadingIcon)
        SpanText(text = label)
        if (trailingIcon != null) IconSlot(trailingIcon)
    }
}
